import { render, staticRenderFns } from "./m_products.vue?vue&type=template&id=136d317c&scoped=true&"
import script from "./m_products.vue?vue&type=script&lang=js&"
export * from "./m_products.vue?vue&type=script&lang=js&"
import style0 from "./m_products.vue?vue&type=style&index=0&id=136d317c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136d317c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('136d317c')) {
      api.createRecord('136d317c', component.options)
    } else {
      api.reload('136d317c', component.options)
    }
    module.hot.accept("./m_products.vue?vue&type=template&id=136d317c&scoped=true&", function () {
      api.rerender('136d317c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/modifiers/items/tabs/m_products.vue"
export default component.exports